module.exports = __webpack_public_path__ + "static/media/oxomoco.eb1049af.jpg";